import allInput from './input/zz';
import allSelect from './select/zz';
import allDate from './date/zz';

const allSearch = [...allInput, ...allSelect, ...allDate];

// 检测重名
const map = {};
let repeat = false;
let emptyKind = false;
allSearch.forEach((item) => {
  if (!item.kind) {
    emptyKind = item;
  } else if (map[item.kind]) {
    repeat = [map[item.kind], item];
  } else {
    map[item.kind] = item;
  }
});
if (emptyKind) {
  console.error('搜索组件缺少kind', emptyKind);
  throw new Error('搜索组件缺少kind');
}
if (repeat) {
  console.error('搜索组件发现重名:', repeat[0].kind, repeat);
  throw new Error('搜索组件发现重名:');
}

export default map;
